import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './index.less'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { selectBackground, checkAllBtn, checkDetailBtn } from '@/assets/images'
import {
  EyeOutlined,
  CloudDownloadOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined
} from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { getAuthorInfo, getWorkRequest, SRC_URL } from '@/server'
import { setShowWorkId as _setShowWorkId } from '@/features/SetShowWorkId/setShowWorkId'
import {
  setShowType,
  setInfoKey,
  setInfoValue
} from '@/features/SetIndexSecondInfo/setIndexSecondInfo'
interface showListI {
  id: string
  dynasty?: string | null
  name: string | null
  museum: string | null
  src: string | null
}
interface typeListI {
  name: string
  type: string
  showList: showListI[]
}

const AUTHOR_COMPACT_CARDS_QUERY = '(max-width: 1130px)'

function getAuthorPaintingsPerPage() {
  if (typeof window === 'undefined') return 4

  return window.matchMedia(AUTHOR_COMPACT_CARDS_QUERY).matches ? 3 : 4
}

function useAuthorPaintingsPerPage() {
  const [paintingsPerPage, setPaintingsPerPage] = useState(getAuthorPaintingsPerPage)

  useEffect(() => {
    const mediaQuery = window.matchMedia(AUTHOR_COMPACT_CARDS_QUERY)
    const handleChange = () => setPaintingsPerPage(mediaQuery.matches ? 3 : 4)

    handleChange()
    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [])

  return paintingsPerPage
}

function resetSecondAreaTracks() {
  document.querySelectorAll<HTMLElement>('.second-area').forEach((element) => {
    element.style.transform = 'translate(0px,0px)'
  })
}

function moveSecondAreaTrack(id: string, index: number, startIndex: number) {
  const element = document.getElementById(id + index)
  const firstItem = element?.children[0] as HTMLElement | undefined

  if (!element || !firstItem) return

  const width = firstItem.clientWidth
  const marginRight = Number(getComputedStyle(firstItem).marginRight.replace('px', '')) || 0
  const offset = (width + marginRight) * startIndex

  element.style.transform = `translate(-${offset}px,0px)`
  element.style.transitionDuration = '.5s'
}

export function AuthorInfoPage() {
  const token = useAppSelector((state) => state.login.token)
  const dispatch = useAppDispatch()
  const _navigate = useNavigate()
  const authorId = useAppSelector((state) => state.authorId.id)
  const paintingsPerPage = useAuthorPaintingsPerPage()
  //作者信息
  const [author, setAuthor] = useState<{
    id: string
    name: string | null
    birth: string | null
    city: string | null
    death: string | null
    dynasty: string | null
    hao: string | null
    introduction: string | null
    origin: string | null
    province: string | null
    stylename: string | null
    zhainame: string | null
  }>()

  //作者总作品集列表
  const [worksList, setWorksList] = useState<showListI[]>([])
  //作者主题/类型/画幅的分类作品集
  const [typeList, setTypeList] = useState<typeListI[]>([])
  //每个展示列表中第一个作品的index
  const [showIndex, setShowIndex] = useState<number[]>([])
  //选择展示类型
  const [showType, setShowTypeLocal] = useState<string>('主题')
  //当前展示列表
  const [showList, setShowList] = useState<typeListI[]>([])
  //切换showType的回调
  const handleChangeShowType = function (type: string) {
    if (type === showType) return
    setShowTypeLocal(type)
    setShowList(typeList.filter((item) => item.type === type))
    resetSecondAreaTracks()
  }
  //主题列表中向前翻页的回调
  const handlePre = function (id: string, index: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return x - paintingsPerPage < 0 ? 0 : x - paintingsPerPage
      } else return x
    })
    moveSecondAreaTrack(id, index, newIndex[index])
    setShowIndex(newIndex)
  }
  //主题列表中向后翻页的回调
  const handleNext = function (id: string, index: number, len: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return Math.min(x + paintingsPerPage, Math.max(0, len - paintingsPerPage))
      } else return x
    })
    moveSecondAreaTrack(id, index, newIndex[index])
    setShowIndex(newIndex)
  }
  //点击查看详情事件
  const handleCheckDetail = function (id: string) {
    window.open('/details/' + id + '/null')
  }
  // 查看该作者所有画作
  function handleCheckAllButton() {
    dispatch(setShowType('painting'))
    dispatch(setInfoKey('author'))
    dispatch(setInfoValue(`${authorId}_${author?.name}`))
    // navigate("./indexSecond")
    window.open('/indexSecond')
  }
  const type2key = {
    主题: 'class1',
    技法: 'class2',
    画幅: 'style'
  }
  // 查看该作者对应标签画作
  function handleCheckSthButton(item) {
    dispatch(setShowType('painting'))
    dispatch(setInfoKey(`author-${type2key[item.type]}`))
    dispatch(setInfoValue(`${authorId}-${item.name}-${author?.name}-${item.type}-${item.name}`))
    window.open('/indexSecond')
  }
  //获取作者信息以及其作品数据
  useEffect(() => {
    //作者信息
    getAuthorInfo(
      {
        authorid: authorId
      },
      token
    ).then((res) => {
      const authorObj: {
        id: string
        name: string | null
        birth: string | null
        city: string | null
        death: string | null
        dynasty: string | null
        hao: string | null
        introduction: string | null
        origin: string | null
        province: string | null
        stylename: string | null
        zhainame: string | null
      } = {
        id: res.data.content.authorid,
        name: res.data.content.authornamecn,
        birth: res.data.content.birth,
        city: res.data.content.city,
        death: res.data.content.death,
        dynasty: res.data.content.dynasty,
        hao: res.data.content.hao,
        introduction: res.data.content.introduction,
        origin: res.data.content.origin,
        province: res.data.content.province,
        stylename: res.data.content.stylename,
        zhainame: res.data.content.zhainame
      }
      setAuthor(authorObj)
    })
    const getRequestData = (key?: string, value?: number | string) => {
      const obj: {
        criteria: { key: string; value: number | string }[]
        pages: { page: number; size: number }
      } = {
        criteria: [{ key: 'author', value: authorId }],
        pages: {
          page: 1,
          size: 10
        }
      }
      if (key && value) obj.criteria.push({ key, value })
      return obj
    }
    //作品列表
    getWorkRequest(getRequestData(), token).then((res) => {
      setWorksList(
        res.data.content.list.map((item) => {
          return {
            id: item.workid,
            dynasty: item.dynasty,
            name: item.workname,
            museum: item.instname,
            src: item.encoding
          }
        })
      )
    })

    const dataArr: Promise<any>[] = []
    //主题class1：山水、人物、花鸟
    const class1Arr: string[] = ['山水', '人物', '花鸟']
    //类型class2：工笔、写意、兼工带写
    const class2Arr: string[] = ['工笔', '写意', '兼工带写']
    for (let i = 0; i < 3; i++) {
      dataArr.push(getWorkRequest(getRequestData('class1', class1Arr[i]), token))
    }
    for (let i = 0; i < 3; i++) {
      dataArr.push(getWorkRequest(getRequestData('class2', class2Arr[i]), token))
    }
    //画幅：立轴、条屏、中堂、横幅、长卷、册页、扇面、镜片
    const paintingSize = ['立轴', '条屏', '中堂', '横幅', '长卷', '册页', '扇面', '镜片']
    for (let i = 0; i < paintingSize.length; i++) {
      dataArr.push(getWorkRequest(getRequestData('style', paintingSize[i]), token))
    }
    //数据全部取到后，再更新列表
    Promise.all(dataArr).then((values) => {
      let workList: showListI[] = []
      const list: typeListI[] = []
      for (let i = 0; i < values.length; i++) {
        workList = values[i].data.content.list.map((item) => {
          return {
            id: item.workid,
            name: item.workname,
            museum: item.instname,
            src: item.encoding
          }
        })
        let name, type
        switch (i) {
          case 0:
            name = '山水'
            type = '主题'
            break
          case 1:
            name = '人物'
            type = '主题'
            break
          case 2:
            name = '花鸟'
            type = '主题'
            break
          case 3:
            name = '工笔'
            type = '技法'
            break
          case 4:
            name = '写意'
            type = '技法'
            break
          case 5:
            name = '兼工带写'
            type = '技法'
            break
          case 6:
            name = '立轴'
            type = '画幅'
            break
          case 7:
            name = '条屏'
            type = '画幅'
            break
          case 8:
            name = '中堂'
            type = '画幅'
            break
          case 9:
            name = '横幅'
            type = '画幅'
            break
          case 10:
            name = '长卷'
            type = '画幅'
            break
          case 11:
            name = '册页'
            type = '画幅'
            break
          case 12:
            name = '扇面'
            type = '画幅'
            break
          case 13:
            name = '镜片'
            type = '画幅'
            break
          default:
            break
        }
        const obj: typeListI = { name: name, type: type, showList: workList }
        list.push(obj)
      }
      setTypeList(list)
    })
  }, [])
  //初始化showList
  useEffect(() => {
    //默认为“主题”
    setShowList(typeList.filter((item) => item.type === '主题'))
  }, [typeList])

  //同步showIndex数组
  useEffect(() => {
    const newArr: number[] = new Array(showList.length).fill(0)
    setShowIndex([...newArr])
    resetSecondAreaTracks()
  }, [showList, paintingsPerPage])
  const categoriesList = ['主题', '技法', '画幅']
  return (
    <>
      <div className='header-container'>
        <Header />
      </div>
      <div className='body-container'>
        <div className='intro-area'>
          <div className='intro-title'>{author?.name}</div>
          <div className='intro-content'>{author?.introduction}</div>
        </div>
        <div className='works-list-area'>
          <div className='works-list'>
            <div className='works-title'>作品列表</div>
            <div className='line'></div>
            <div className='works-content'>
              {worksList?.map((item) => {
                return (
                  <>
                    <div className='work-item' key={item.name}>
                      <div className='point'></div>
                      <div className='work-name' title={item.name ?? ''}>
                        {item.name}
                      </div>
                      <div className='work-museum' title={item.museum ?? ''}>
                        {item.museum}
                      </div>
                      <div className='arrow' onClick={(_e) => handleCheckDetail(item.id)}>
                        <ArrowRightOutlined
                          style={{
                            margin: 3,
                            color: 'rgb(51, 44, 25)'
                          }}
                        />
                      </div>
                    </div>
                    <div className='line'></div>
                  </>
                )
              }) ?? ''}
            </div>
            <div className='check-all-btn' onClick={() => handleCheckAllButton()}>
              <img src={checkAllBtn} alt='查看所有画作' />
            </div>
          </div>
        </div>
        <div className='select-area'>
          {categoriesList.map((type) => {
            return (
              <div
                className='select-item'
                style={{ color: showType === type ? 'white' : 'black' }}
                onClick={() => handleChangeShowType(type)}
                key={type}
              >
                <img
                  style={{ display: showType === type ? 'block' : 'none' }}
                  src={selectBackground}
                  alt=''
                />
                &nbsp;{type}
              </div>
            )
          })}
        </div>
        {showList?.map((items, index) => {
          const paintingList = items.showList
          const paintingsLen = paintingList.length
          const currentShowIndex = showIndex[index] ?? 0
          const isLastPage = currentShowIndex >= Math.max(0, paintingsLen - paintingsPerPage)
          return paintingsLen > 0 ? (
            <div className='theme-list'>
              <div className='first-area'>
                <div className='theme-title'>{items.name}</div>
                <div className='btn-box'>
                  <div
                    className={'btn ' + (currentShowIndex === 0 ? 'disabled' : 'abled')}
                    onClick={(_e) => handlePre(items.name, index)}
                  >
                    <ArrowLeftOutlined
                      style={{
                        margin: 'auto',
                        color: currentShowIndex === 0 ? 'rgb(180, 179, 173)' : 'rgb(72, 66, 51)'
                      }}
                    />
                  </div>
                  <div
                    className={'btn ' + (isLastPage ? 'disabled' : 'abled')}
                    onClick={(_e) => handleNext(items.name, index, paintingsLen)}
                  >
                    <ArrowRightOutlined
                      style={{
                        margin: 'auto',
                        color: isLastPage ? 'rgb(180, 179, 173)' : 'rgb(72, 66, 51)'
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='painting-list-viewport'>
                <div className='second-area' id={items.name + index}>
                  {paintingList.map((item, paintingIndex) => {
                    return (
                      <div className='painting-item' key={paintingIndex}>
                        <div className='painting' onClick={(_e) => handleCheckDetail(item.id)}>
                          <img src={item.src ? SRC_URL + item.src : ''} alt='画作' />
                          <div className='painting-desc'>
                            <div className='painting-pos-box'>
                              <div className='painting-name' title={item.name ?? ''}>
                                {item.name}
                              </div>
                              <div className='painting-museum' title={item.museum ?? ''}>
                                {item.museum}
                              </div>
                              <div className='icon-box'>
                                <EyeOutlined
                                  style={{
                                    color: '#fff',
                                    fontSize: 22
                                  }}
                                />
                                &nbsp;
                                <CloudDownloadOutlined
                                  style={{
                                    color: '#fff',
                                    fontSize: 22
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className='check-detail-btn'
                          onClick={(_e) => handleCheckDetail(item.id)}
                        >
                          <img src={checkDetailBtn} alt='查看详情' />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className='third-area'>
                <div className='check-all-btn'>
                  <img
                    src={checkAllBtn}
                    alt='查看所有画作'
                    onClick={() => {
                      handleCheckSthButton(items)
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <></>
          )
        }) ?? ''}
      </div>
      <div className='footer-container'>
        <Footer />
      </div>
    </>
  )
}
